var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1085"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52",
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#28C76F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 56",
    d: "M22.8662 30.3992L16.177 24.0513C15.9578 23.8433 15.6145 23.8423 15.3941 24.0489L12.2825 26.9665C12.0426 27.1914 12.042 27.5721 12.2813 27.7977L22.4688 37.4019C22.691 37.6114 23.0388 37.6087 23.2578 37.3958L41.3068 19.8448C41.5354 19.6225 41.5374 19.2559 41.3113 19.0312L38.4431 16.1806C38.2232 15.9619 37.8688 15.9591 37.6454 16.1742L22.8662 30.3992Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.5cd132b1cdf0bfaeecda6e24aacf0dab.svg";
export { ForwardRef as ReactComponent };